/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApproveAgentRequest { 
    id: string;
    isApproved: boolean;
    name: string;
    comment?: string | null;
    facilityId: string;
}

